<template>
  <v-container>
    <v-data-table
        :headers="headers"
        :items="vehicles"
    >
      <template v-slot:item.actions="{ item }">
        <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
            small
            @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>

    <v-dialog
        v-model="deleteDialog"
        width="500"
    >
      <DeleteDialog :close-delete="closeDeleteDialog" :delete-item-confirm="confirmVehicleDelete"/>
    </v-dialog>

    <v-dialog
        v-model="editDialog"
        width="600"
    >
      <CreateDialog
          :form-title="'Edit Vehicle Details'"
          :close-function="closeEditDialog"
          :save-function="confirmVehicleEdit"
          :item="editVehicle"
          :has-cost="true"
          :drivers="drivers"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import CreateDialog from "@/components/vehicle-type/CreateDialog";
import DeleteDialog from "@/components/vehicle-type/DeleteDialog";
export default {
  name: "ServiceAreaVehicleTypes",
  components: { DeleteDialog, CreateDialog },
  props: {
    vehicles: Array,
    wasteTypeKey: String,
    serviceAreaId: String,
    removeVehicle: Function,
    updateVehicle: Function,
    drivers: Array
  },
  data() {
    return {
      deleteDialog: false,
      editDialog: false,
      editVehicle: {},
      headers: [
        { text: 'Unique Id', value: 'key' },
        { text: 'Name', value: 'name' },
        { text: 'Type', value: 'type'},
        { text: 'Cost', value: 'cost'},
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      mappedVehicles: []
    }
  },
  methods: {
    editItem (item) {
      this.editedIndex = this.vehicles.indexOf(item)
      this.editVehicle = Object.assign({}, item)
      this.editDialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.vehicles.indexOf(item)
      this.editVehicle = Object.assign({}, item)
      this.deleteDialog = true;
    },
    closeDeleteDialog() {
      this.deleteDialog = false;
    },
    closeEditDialog() {
      this.editDialog = false;
    },
    confirmVehicleDelete() {
      this.removeVehicle(this.editVehicle.key, this.wasteTypeKey, this.serviceAreaId);
      this.closeDeleteDialog();
    },
    confirmVehicleEdit() {
      this.updateVehicle(this.editVehicle, this.wasteTypeKey, this.serviceAreaId);
      this.closeEditDialog();
    }
  }
}
</script>

<style scoped>

</style>